export const Envs = {
  BFF_WEB_URL: process.env['NEXT_PUBLIC_HUB_API'] ?? process.env['REACT_APP_HUB_API'] ?? process.env['NX_BFF_WEB_URL'],
  APP_HOST: process.env['NEXT_PUBLIC_APP_URL'] ?? process.env['REACT_APP_APP_URL'] ?? process.env['NX_APP_URL'],
  COOKIE_DOMAIN:
    process.env['NX_COOKIE_DOMAIN'] ??
    process.env['REACT_APP_COOKIE_DOMAIN'] ??
    process.env['NEXT_PUBLIC_COOKIE_DOMAIN'],
  SITE_URL: process.env['NEXT_PUBLIC_SITE_URL'] ?? process.env['REACT_APP_SITE_URL'] ?? process.env['NX_SITE_URL'],
}
